var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.92px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roll_brush",
    "data-name": "roll brush"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.73,
    cy: 13.45,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.65,
    cy: 18.24,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.69,
    cy: 8.65,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.52,
    cy: 5.78,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.32,
    cy: 6.74,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.2,
    cy: 10.57,
    r: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.51,11.86a4.87,4.87,0,0,1-4.86,4.95H16.18a4.28,4.28,0,0,0-3.57,1.91l-1.15,1.72a4.74,4.74,0,0,1-4,2.12h0a4.61,4.61,0,0,1-3.87-2A13.07,13.07,0,0,1,1.41,13.3V12a10.55,10.55,0,0,1,21.1-.15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSvgrepoCom);
export default __webpack_public_path__ + "static/media/color-svgrepo-com.29165ffa1cc8a8bde8e2c4f14aa98dcc.svg";
export { ForwardRef as ReactComponent };